import { scrollToElem } from '../../utils'

export default {
	data() {
		return {
            depositCurrentInfoTab: '',
            docsOpened: false
		}
	},
    computed: {
        isSavingsAccount() {
            return ['savings-account', 'savings-account-private'].includes(this.product);
        },
        isMoyDom() {
            return this.product === 'vklad-moy-dom'
        }
    },
    methods: {
        openDocs() {
            this.currentTab = 'third';
            this.docsOpened = true;
            scrollToElem('docs')
        },
        scrollToElem(elem) {
            scrollToElem(elem)
        },
        daysToMonths(days) {
            let res;
            switch(days) {
                case '61': res = '2 мес.'; break;
                case '91': res = '3 мес.'; break;
                case '122': res = '4 мес.'; break;
                case '181': res = '6 мес.'; break;
                case '274': res = '9 мес.'; break;
                case '367': res = '1 год'; break;
                case '550': res = '1,5 года'; break;
                case '730': res = '2 года'; break;
                case '1100': res = '3 года'; break;
                case '1450': res = '4 года'; break;
                case '1795': res = '5 года'; break;
                default: res = '';
            }

            return res;
        },
        depositSetInfoTab(tabName) {
            this.depositCurrentInfoTab = tabName;
        }
    }
}
